import { useQuery } from "@tanstack/react-query";
import { allocationAndUnlockProgressQueryOptions } from "@/services/queries/tokenPage/utilityValueQueries";
import type { TokenUnlocksResponse } from "@/types/tokenDashboard/utilityTab";

interface UseAllocationAndUnlockProgressReturn {
  data: TokenUnlocksResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useAllocationAndUnlockProgress(
  tokenId: string
): UseAllocationAndUnlockProgressReturn {
  const query = useQuery({
    ...allocationAndUnlockProgressQueryOptions(tokenId),
    enabled: !!tokenId,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
